<p>
  admin-rapid-delivery-create works!
</p>
